import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { PublicShell } from "./PublicLandingPage";
import PublicCalendar from "../components/PublicCalendar";
import { BookingHeader } from "../components/BookingChrome";
import { getTemplate, mergeBranding } from "../lib/templates";
import { trackFunnel } from "../lib/track";

export default function PublicEventPage({ preview = false }) {
  const { slug, eventSlug } = useParams();
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const [selected, setSelected] = useState(null);
  const [liveBranding, setLiveBranding] = useState(null);
  const gotMessageRef = useRef(false);

  useEffect(() => {
    (async () => {
      try {
        let es = eventSlug;
        if (!es) {
          const list = await api.get(`/public/attraction/${slug}`);
          es = (list.data.events || [])[0]?.slug;
          if (!es) { setErr("No events available."); return; }
        }
        const r = await api.get(`/public/attraction/${slug}/event/${es}`);
        setData(r.data);
        if (!preview) trackFunnel("visit", { attraction_id: r.data.attraction?.id, event_id: r.data.event?.id, window_days: r.data.attraction?.attribution_window_days });
        if (preview && !gotMessageRef.current) setLiveBranding((cur) => cur ?? (r.data.attraction.branding || {}));
      } catch { setErr("This event isn't available."); }
    })();
  }, [slug, eventSlug, preview]);

  useEffect(() => {
    if (!preview) return undefined;
    const handler = (e) => {
      if (e?.data?.type === "BRANDING_UPDATE" && e.data.branding) { gotMessageRef.current = true; setLiveBranding(e.data.branding); }
    };
    window.addEventListener("message", handler);
    try { window.parent?.postMessage({ type: "PREVIEW_READY" }, "*"); } catch (_) {}
    return () => window.removeEventListener("message", handler);
  }, [preview]);

  if (err) return <PublicShell><div className="text-center py-32 text-[#fca5a5]">{err}</div></PublicShell>;
  if (!data) return <PublicShell><div className="text-center py-32 text-[#8a8a8a]">Loading…</div></PublicShell>;

  const a = data.attraction;
  const b = mergeBranding(preview ? liveBranding : a.branding);
  const aShell = preview ? { ...a, branding: b } : a;
  const tplId = getTemplate(b.template_id || "default").id;

  const onPick = (sel) => {
    setSelected(sel);
    if (!preview && sel?.date_id) nav(`/${slug}/date/${sel.date_id}`);
  };

  return (
    <PublicShell attraction={aShell} hideLogo>
      <BookingHeader attraction={a} branding={b} />

      {tplId === "haunt" && <div className="haunt-divider" />}
      {tplId === "carnival" && <div className="tpl-ornament" aria-hidden="true">✦ ✦ ✦</div>}

      <div className="booking-body" data-testid="booking-body">
        <div className="cal-container pc-panel">
          <h2 className="pc-heading" data-testid="calendar-heading">{b.calendar_heading || "Pick your night"}</h2>
          {data.dates.length === 0
            ? <div className="text-center py-10 text-[#8a8a8a]">No dates available yet — check back soon.</div>
            : <PublicCalendar dates={data.dates} attraction={aShell} selected={selected?.date} onPick={onPick} />}
        </div>
      </div>

      {tplId === "carnival" && <div className="tpl-ornament" aria-hidden="true">✦ ✦ ✦</div>}
    </PublicShell>
  );
}
